export default "__VITE_ASSET__pvz$1$ty__"